import Graylog from 'components/domain/analytics/Graylog/Graylog';
import { useActiveMember } from 'hooks';
import { useCallback, useMemo } from 'react';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';

function useDashboardAnalytics() {
  const member = useActiveMember();

  const recordPendingSafetyTasksClick = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.dashboard.CLICK_PENDING_SAFTY_TASK_CARD,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  return useMemo(
    () => ({
      recordPendingSafetyTasksClick,
    }),
    [recordPendingSafetyTasksClick]
  );
}

export default useDashboardAnalytics;
